'use strict';

goog.provide("Ntry.MazeSystem");

goog.require("Ntry.STATIC");

Ntry.MazeSystem = function() {
    this._unit;

    /* to detect position change */
    this._unitGrid = {x: -1, y: -1};

    this._eventDelay = null;
    this._eventTileType = null;

    this._goalCount = 0;
    this._itemCount = 0;

    Ntry.addEventListener("stop", this, this.clearGoal);
    Ntry.addEventListener("raiseItem", this, this.countGoal);
    Ntry.addEventListener("itemFire", this, this.getGoal);
    Ntry.addEventListener("executeEnd", this, this.checkEnd);
    Ntry.addEventListener("fail" , this, this.fail);
};

(function(p){
    p.TILE_EVENT = {};
    p.TILE_EVENT[Ntry.STATIC.WALL] = Ntry.STATIC.WALL_CRASH;
    p.TILE_EVENT[Ntry.STATIC.OBSTACLE_ELECTRIC] = Ntry.STATIC.ELECTRIC_SHOCK;
    p.TILE_EVENT[Ntry.STATIC.OBSTACLE_BEE] = Ntry.STATIC.BEE_ATTACK;
    p.TILE_EVENT[Ntry.STATIC.OBSTACLE_BANANA] = Ntry.STATIC.SLIP;
    p.TILE_EVENT[Ntry.STATIC.OBSTACLE_SIGN] = Ntry.STATIC.WALL_CRASH;
    p.TILE_EVENT[Ntry.STATIC.OBSTACLE_SLOW] = Ntry.STATIC.GO_SLOW_CRASH;

    p.EVENT_DELAY = {};
    p.EVENT_DELAY[Ntry.STATIC.WALL] = 2;
    p.EVENT_DELAY[Ntry.STATIC.OBSTACLE_ELECTRIC] = 10;
    p.EVENT_DELAY[Ntry.STATIC.OBSTACLE_BEE] = 7;
    p.EVENT_DELAY[Ntry.STATIC.OBSTACLE_BANANA] = 3;
    p.EVENT_DELAY[Ntry.STATIC.OBSTACLE_SIGN] = 5;
    p.EVENT_DELAY[Ntry.STATIC.OBSTACLE_SLOW] = 2;

    p.update = function () {
        /* register tile info - when to optimize
         * raise event
         * obstacle
         * objectives
         */

        if (!this._unit)
            this.findUnit();
        else if (!Ntry.entityManager.hasComponent(this._unit.id, Ntry.STATIC.UNIT))
            this.findUnit();
        if (!this._unit)
            return;

        var unitGrid = Ntry.entityManager.getComponent(
            this._unit.id, Ntry.STATIC.GRID);

        /* update grid */
        if (this._unitGrid.x != unitGrid.x || this._unitGrid.y != unitGrid.y) {
            this._unitGrid = {
                x: unitGrid.x, y: unitGrid.y
            }

            var groundTileComp = this.getTile(this._unitGrid);
            var tileType;
            if (!groundTileComp)
                tileType = Ntry.STATIC.WALL;
            else
                tileType = groundTileComp.tileType;
            this.dispatchGroundEvent(tileType)
        }

        if (this._eventDelay) {
            this._eventDelay--;
            if (this._eventDelay == 0) {
                this._dispatchGroundEvent(this._eventTileType)
                this._eventDelay = null;
            }
        }
    };

    p.clearGoal = function(itemType) {
        this._goalCount = 0;
        this._itemCount = 0;
    };

    p.countGoal = function(itemType) {
        if (itemType == Ntry.STATIC.GOAL_ITEM)
            this._goalCount++;
        else if (itemType == Ntry.STATIC.JR_ITEM)
            this._itemCount++;
    };

    p.getGoal = function(itemType) {
        if (itemType == Ntry.STATIC.JR_ITEM) {
            this._itemCount--;
        } else if (itemType == Ntry.STATIC.GOAL_ITEM) {
            this._goalCount--;
            if (this._goalCount == 0 && this._itemCount == 0) {
                Ntry.dispatchEvent("playSound", "mazeSuccess");
                Ntry.dispatchEvent("complete", true);
            } else if (this._itemCount != 0 ) {
                Ntry.dispatchEvent("complete",false, Ntry.STATIC.WITHOUT_ITEM_SUCCESS);
            } else if (this._goalCount == 0) {
                Ntry.dispatchEvent("unitAction", Ntry.STATIC.SIMOOROOK);
            }
        }
    };

    p.fail = function() {
        Ntry.dispatchEvent("unitAction" , Ntry.STATIC.FAIL);
    };

    p.checkEnd = function() {
        if (this._goalCount == 0) {
            Ntry.dispatchEvent("playSound", "mazeSuccess");
            Ntry.dispatchEvent("complete", true);
        } else
            Ntry.dispatchEvent("unitAction", Ntry.STATIC.SIMOOROOK);
    };

    p.dispatchGroundEvent = function(tileType) {
        var event = this.TILE_EVENT[tileType];
        if (!event)
            return;
        this._eventDelay = this.EVENT_DELAY[tileType]
        this._eventTileType = tileType;
    }

    p._dispatchGroundEvent = function(tileType) {
        var event = this.TILE_EVENT[tileType];
        Ntry.dispatchEvent("unitAction", event);
    }

    p.getTile = function(unitPos) {
        var entities = Ntry.entityManager.getEntitiesByComponent(
            Ntry.STATIC.TILE);

        var groundTile;
        for (var id in entities) {
            var entity = entities[id];
            var gridComp = Ntry.entityManager.getComponent(
                entity.id, Ntry.STATIC.GRID);
            if (gridComp.x == unitPos.x && gridComp.y == unitPos.y) {
                var tile = Ntry.entityManager.getComponent(
                    entity.id, Ntry.STATIC.TILE);
                if (groundTile && groundTile.tileType != Ntry.STATIC.ROAD)
                    continue;
                groundTile = tile;
            }
        }
        return groundTile;
    }

    p.findUnit = function() {
        var entities = Ntry.entityManager.getEntitiesByComponent(
            Ntry.STATIC.UNIT);

        for (var key in entities)
            this._unit = entities[key];
    }

})(Ntry.MazeSystem.prototype);
